import { useState, forwardRef, useImperativeHandle } from 'react';
import { Drawer } from 'antd';
import MyFlex from '../myFlex/MyFlex';
import { useTranslation } from 'react-i18next';
import UtilString from '../../utils/UtilString';
import MyButtonSuccess from '../myButton/MyButtonSuccess';
import MyButtonSecondary from '../myButton/MyButtonSecondary';

const MyDrawer = forwardRef(
  (
    {
      size,
      icon,
      title,
      label,
      style,
      loading,
      children,
      formName,
      btnStyle,
      noExtraBtn,
      forceRender,
      destroyOnHidden,
      closable = true,
      placement = 'right',
      className = UtilString.EMPTY_STRING,
      btnClassName = UtilString.EMPTY_STRING,
    },
    ref
  ) => {
    const { t } = useTranslation();

    const [visible, setVisible] = useState(false);

    const showDrawer = () => {
      setVisible(true);
    };

    const closeDrawer = () => {
      setVisible(false);
    };

    useImperativeHandle(ref, () => ({
      showDrawer: showDrawer,
      closeDrawer: closeDrawer,
    }));

    return (
      <>
        <div className={btnClassName}>
          <MyButtonSecondary
            icon={icon}
            label={label}
            style={btnStyle}
            loading={loading}
            onClick={showDrawer}
          />
        </div>
        <Drawer
          title={title}
          placement={placement}
          onClose={closeDrawer}
          open={visible}
          className={className}
          forceRender={forceRender}
          destroyOnHidden={destroyOnHidden}
          // getContainer={false}
          style={style}
          closable={closable}
          size={size}
          extra={
            noExtraBtn ? null : (
              <MyFlex>
                <MyButtonSecondary
                  onClick={closeDrawer}
                  label={t('WORD_CANCEL')}
                />
                <MyButtonSuccess
                  form={formName}
                  onClick={closeDrawer}
                  label={t('WORD_APPLY')}
                />
              </MyFlex>
            )
          }
        >
          {children}
        </Drawer>
      </>
    );
  }
);

export default MyDrawer;
